import React from 'react';
import { defineMessages } from 'react-intl';

const messages = defineMessages({
  previousTip: {
    id: 'containers.Tour.previousTip',
    defaultMessage: 'Previous Tip'
  },
  nextTip: {
    id: 'containers.Tour.nextTip',
    defaultMessage: 'Next Tip'
  },
  finish: {
    id: 'containers.Tour.finish',
    defaultMessage: 'Finish'
  },
  feedWelcome: {
    id: 'containers.Tour.feed.welcome',
    defaultMessage: '<p>Welcome to your <strong>updated Feed page<strong/>!</p><p>Here you can see all the content you\'re following on ArchDaily.</p>',
  },
  feedFolders: {
    id: 'containers.Tour.feed.folders',
    defaultMessage: '<p>All your folders and bookmarks are now kept in the improved Folders page <strong>below</strong>.</p>',
  },
  foldersWelcome: {
    id: 'containers.Tour.folders.welcome',
    defaultMessage: 'Welcome to your updated Folders page! You can now sort your folders and bookmarks alphabetically and by date. Just use the Sort button below.'
  },
  foldersSearch: {
    id: 'containers.Tour.folders.search',
    defaultMessage: 'You can also search through your Folders and Bookmarks. Just use the search bar above.'
  },
  foldersTogether: {
    id: 'containers.Tour.folders.together',
    defaultMessage: 'All of your folders (private and public) are stored together so you can easily manage them.'
  }
});

export default messages;